import { tv } from "../../variants/tv.js";
const notificationBadgeVariants = tv({
    slots: {
        wrapper: 'relative isolate inline-flex items-center justify-center',
        badge: 'flex items-center justify-center overflow-hidden rounded-full border border-solid text-center text-body3 [line-height:1] font-medium',
        content: 'relative z-[1]'
    },
    variants: {
        size: {
            md: {
                badge: 'min-h-5 min-w-5 px-0.5'
            },
            sm: {
                badge: 'min-h-4 min-w-4 px-0.5'
            },
            xs: {
                badge: 'size-1.5 p-0'
            }
        },
        emphasis: {
            regular: {},
            medium: {},
            bold: {}
        },
        standalone: {
            true: {
                badge: ''
            },
            false: {
                badge: 'absolute z-[2] shadow-[0px_0px_0px_1px_white]'
            }
        }
    },
    compoundVariants: [
        {
            size: 'xs',
            class: {
                badge: 'border-urgency-1 bg-urgency-8'
            }
        },
        {
            emphasis: 'regular',
            size: [
                'md',
                'sm'
            ],
            class: {
                badge: 'border-urgency-8 bg-urgency-1 text-urgency-11'
            }
        },
        {
            emphasis: 'medium',
            size: [
                'md',
                'sm'
            ],
            class: {
                badge: 'border-urgency-4 bg-urgency-3 text-urgency-11'
            }
        },
        {
            emphasis: 'bold',
            size: [
                'md',
                'sm'
            ],
            class: {
                badge: 'border-urgency-1 bg-urgency-8 text-urgency-1'
            }
        }
    ],
    defaultVariants: {
        size: 'md',
        emphasis: 'regular',
        standalone: true
    }
});
const notificationBadgeSizes = Object.keys(notificationBadgeVariants.variants.size);
const notificationBadgeEmphases = Object.keys(notificationBadgeVariants.variants.emphasis);
export { notificationBadgeEmphases, notificationBadgeSizes, notificationBadgeVariants };
